document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        document.querySelectorAll('.quantity_break_table tbody tr').forEach((row) => {
        const td = row.querySelector('td');
        if (!td) return;

        const originalText = td.textContent.trim();

        // Case 1: format "2 - 2", "3 - 3", v.v.
        const matchEqualRange = originalText.match(/^(\d+)\s*-\s*\1$/);
        if (matchEqualRange) {
            td.textContent = `${matchEqualRange[1]} boxes`;
            return;
        }

        // Case 2: format "≥ 3"
        const matchGreaterEqual = originalText.match(/^≥\s*(\d+)/);
        if (matchGreaterEqual) {
            td.textContent = `${matchGreaterEqual[1]}+ boxes`;
            return;
        }
        });                                     
    }, 2000);
})
